// Generated by scripts/build-ui-icons.mjs.
export { Headset as default } from "../ui/glyphs-4";
